import { useCallback, useState } from "react";
import { Avatar, Flex, Text } from "@mantine/core";
import { IconUpload, IconX } from "@tabler/icons-react";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { uploadImage } from "../api";
import { rem } from "@mantine/core";

function ImageUploader({ imageType, onProfileUpdated, message, image }) {
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setIsUploading(true);
      const file = acceptedFiles[0];
      uploadImage(file, imageType)
        .then((data) => {
          // this returns the entire profile
          setIsUploading(false);
          onProfileUpdated(data);
        })
        .catch((err) => {
          // TBD: Show user-friendly message
          setIsUploading(false);
          console.error(err);
        });
    },
    [isUploading]
  );

  return (
    <div style={{ position: "relative" }}>
      <Dropzone
        onDrop={onDrop}
        onReject={(files) => console.log("rejected files", files)}
        maxSize={4 * 1024 ** 2}
        accept={IMAGE_MIME_TYPE}
        loading={isUploading}
      >
        {/* <Flex m="md" align="center" justify="center" mih={160} style={{ pointerEvents: 'none', border: "3px dashed var(--mantine-color-dark-6)", borderRadius: "var(--mantine-radius-md)" }}> */}
        <Flex
          m="md"
          align="center"
          justify="center"
          mih={160}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconUpload size={55} stroke={1.8} />
            </Avatar>
          </Dropzone.Accept>
          <Dropzone.Reject component="div">
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconX
                style={{
                  width: rem(52),
                  height: rem(52),
                  color: "var(--mantine-color-red-6)",
                }}
                stroke={1.8}
              />
            </Avatar>
          </Dropzone.Reject>
          <div>
            {image ? (
              image
            ) : (
              <Text size="xl" inline>
                {message}
              </Text>
            )}
          </div>
        </Flex>
      </Dropzone>
    </div>
  );
}

export default ImageUploader;
